import { g as getFocusableElements } from './getFocusableElements-BjFtn5aB.js';

function focusFirstElement(element) {
  const focusableEls = getFocusableElements(element);
  if (focusableEls.length > 0) {
    focusableEls[0].focus();
  }
}

export { focusFirstElement as f };
//# sourceMappingURL=focusFirstElement-C1TqGpwr.js.map
